import { C44TestimonialsProps } from './C44Testimonials.types';
import { TESTIMONIAL_CARD_COMPONENT_NAME } from 'src/shared/static';
import { GetTestimonialCardModel } from '../C44TestimonialCard/C44TestimonialCard.service';
import { useI18n } from 'next-localization';
import { TestimonialsProps, TestimonialCardProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function GetTestimonialsModel(props?: C44TestimonialsProps): TestimonialsProps {
  type propType = TestimonialsProps;
  const { rendering, params, fields } = props || {};
  const { renderText, renderRichText } = useConditionalRendering();

  const { t } = useI18n() || {};
  const expandButtonText = t('Testimonials-ExpandButtonText');

  const testimonialCardArray =
    rendering?.placeholders?.['testimonial-cards-{*}']?.filter(
      ({ componentName }) => !!componentName && componentName === TESTIMONIAL_CARD_COMPONENT_NAME
    ) || [];
  const testimonialCards: TestimonialCardProps[] = testimonialCardArray.map((card) =>
    GetTestimonialCardModel(card?.fields)
  );

  const model: TestimonialsProps = {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    backgroundColor: getDroplink<propType['backgroundColor']>(
      params?.BackgroundColor,
      'whiteSmoke'
    ),
    numberOfColumns: getDroplink<propType['numberOfColumns']>(params?.NumberOfColumns, '1'),
    headlineTag: getDroplink<propType['headlineTag']>(params?.HeadlineTag, 'p'),
    contentAlignment: getDroplink<propType['contentAlignment']>(params?.ContentAlignment, 'center'),
    expandButtonText,
    expandButtonAlignment: getDroplink<propType['expandButtonAlignment']>(
      params?.ExpandButtonAlignment,
      'center'
    ),
    showOnlyFirstRowOnLoad: Boolean(params?.ShowOnlyFirstRowOnLoad),
    testimonialCards: testimonialCards,
  };
  return model;
}
